// app/frontend/components/ui/Inputs/StyledTimeInput.tsx
import React, { forwardRef } from 'react';
import { TimeInput, TimeInputProps } from '@mantine/dates';
import { useMediaQuery } from '@mantine/hooks';

import { INPUT_LABEL_FONT_SIZE } from '../../../src/constants/theme';
import { themeVar } from '../../../src/utils/pageTheme';
interface StyledTimeInputProps extends TimeInputProps {
  // Inherit all Mantine TimeInputProps
}

const StyledTimeInput = forwardRef<HTMLInputElement, StyledTimeInputProps>(
  ({ label, styles = {}, size, ...props }, ref) => {
    const isMobile = useMediaQuery('(max-width: 768px)');

    const defaultStyles = {
      input: {
        backgroundColor: '#2c2c2c',
        color: 'white',
        border: '1px solid #444444',
        fontSize: isMobile ? '8px' : '1rem', // 8px mobile, 16px desktop
        fontWeight: 400,
      },
      label: {
        color: '#FFF7ED',
        fontSize: INPUT_LABEL_FONT_SIZE,
      },
      required: {
        color: themeVar('accent-text'), // Asterisk in the accent: orange, or a themed page's own
      },
      ...styles,
    };

    return (
      <TimeInput
        ref={ref}
        label={label}
        styles={defaultStyles}
        size={size || (isMobile ? 'sm' : 'md')}
        {...props}
      />
    );
  }
);

StyledTimeInput.displayName = 'StyledTimeInput';

export default StyledTimeInput;
